/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Rutare 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Bikumba": ["Karugeyo", "Kintaganirwa", "Marembo", "Matyazo", "Nyabisindu"],
  "Gasharu": ["Buyegero", "Kabagabo", "Kabusunzu", "Kagarama", "Rwimbogo", "Yogi"],
  "Gatwaro": ["Bureranyana", "Gashinya", "Kabira", "Kanaba"],
  "Kigabiro": ["Kabuye", "Munini", "Nyakabingo", "Nyakavunga", "Rugarama"],
  "Munanira": ["Bushokanyambo", "Gasharu", "Kirwa", "Mataba", "Ruti"],
  "Nkoto": ["Bariza", "Bwangamwanda", "Murehe", "Nyagatoma", "Nyansenge"]
};